import { ListStore } from '@/main/store/@types/list.d';
import { cellNames, Row } from '@/main/utils/table';

import {
	OZNAC_HROMADNU_OBJ,
	OZNAC_HROMADNY_VYDEJ,
	OZNAC_HROMAD_REZER,
	listMutations,
} from '../types';
import { filter, dropdownList, localState, props } from './state';
import { ZDROJ } from '../../constants';

type State = ListStore<typeof filter, typeof dropdownList, typeof localState, null, typeof props>;

export const mutations = {

	[OZNAC_HROMADNU_OBJ](state: State) {
		state.localState.multipleSelection = [];
		const names = cellNames(state.table);
		state.table.rows.forEach((row: Row) => {
			const { cells } = row;
			let pocetNd = cells[names.POCET_ND] - cells[names.MNOZSTVI_VYD] - cells[names.OBJEDZAK_POC];
			if (state.filter.ZakazkoKratitPrp) {
				pocetNd -= cells[names.DISP_STAV];
			}
			if (pocetNd > 0 && !!cells[names.VYROBEKND_OZN]) {
				state.localState.multipleSelection.push(row);
			}
		});
	},
	[OZNAC_HROMADNY_VYDEJ](state: State) {
		state.localState.multipleSelection = [];
		const { cekatNaObj } = state.localState;
		const checkDispo = !state.props.filter.NabidkaPrp;
		const isPracovnikSetted = !!state.filter.PracovnikId;

		const names = cellNames(state.table);
		state.table.rows.forEach((row) => {
			let pocetNd = row.cells[names.POCET_ND] - row.cells[names.MNOZSTVI_VYD];
			if (checkDispo) {
				pocetNd = Math.min(pocetNd, row.cells[names.DISP_STAV]);
			}
			const isSkladSetable = (state.filter.SkladOzn)
				? (state.filter.SkladOzn === row.cells[names.SKLAD_OZN] || !row.cells[names.SKLAD_OZN])
				: row.cells[names.SKLAD_OZN];

			const shouldCekatNaObj = row.cells[names.ZDROJ_ENUM] === ZDROJ.KOS && cekatNaObj;
			const checkRow = (pocetNd > 0 && isPracovnikSetted && isSkladSetable && !shouldCekatNaObj);
			checkRow && state.localState.multipleSelection.push(row);
		});
	},

	[OZNAC_HROMAD_REZER](state: State) {
		state.localState.multipleSelection = [];
		const names = cellNames(state.table);
		state.table.rows.forEach((row) => {
			const dispStav = row.cells[names.DISP_STAV];
			const pocetNd = row.cells[names.POCET_ND] - row.cells[names.MNOZSTVI_VYD];
			const isSkladSetable = Boolean(row.cells[names.SKLAD_OZN]) || Boolean(state.filter.SkladOzn);

			if (row.cells[names.REZERV_UMOZNIT_PRP] && dispStav >= pocetNd && isSkladSetable) {
				state.localState.multipleSelection.push(row);
			}
		});
	},
	[listMutations.PRACOVNIK_SELECT_MAPPER](state:State, { data }: any) {
		state.filter.PracovnikId = data.value;
		state.filter.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
		state.filter.PracovnikOsobniCis = data.osobniCis;
	},
	[listMutations.ZAKAZKA_SELECT_MAPPER](state: State, { data }: any) {
		state.localState.dialog.ZakazkaId = data.value;
		state.localState.dialog.ZakazkaIdNr = data.nr;
		state.localState.dialog.ZakazkaIdText = data.text;
	},
};
